import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import classNames from "classnames";
import { DeltaBadge } from "../primitives";
import { BandKey, Delta } from "../types";
import SchoolChips, { SchoolRef } from "./SchoolChips";
import styles from "./style.module.scss";

export interface StatusBand {
  key: BandKey | string;
  label: string;
  color: string;
  count: number;
  /** Share of all schools, already formatted, e.g. "43%". */
  share: string;
  delta?: Delta;
  schools: SchoolRef[];
}

interface StatusSplitTileProps {
  bands: StatusBand[];
  /** Key of the band whose school list is expanded, if any. */
  openBand?: string | null;
  onToggleBand?: (key: string) => void;
  onSelectSchool?: (id: number | string) => void;
  definition?: string;
  title?: string;
  className?: string;
}

/** Healthy / Slipping / Dead split, each row expanding to its school list. */
function StatusSplitTile({
  bands,
  openBand,
  onToggleBand,
  onSelectSchool,
  definition,
  title = "School status split",
  className,
}: StatusSplitTileProps) {
  return (
    <div className={classNames(styles.tile, styles.splitTile, className)}>
      <div className={styles.splitBody}>
        <div className={styles.splitHead}>
        <div className={styles.splitTitle}>{title}</div>
        <span className={styles.splitIcon}>
          <DonutSmallIcon />
        </span>
      </div>

      <div className={styles.bandList}>
        {bands.map((band) => {
          const open = openBand === band.key;

          return (
            <div key={band.key} className={styles.bandGroup}>
              <div className={styles.bandRow}>
                <div className={styles.bandLabel}>
                  <span className={styles.dot} style={{ background: band.color }} />
                  <span className={styles.bandName}>{band.label}</span>
                </div>
                <span className={styles.bandShare}>{band.share}</span>
                <span className={styles.bandCount}>{band.count}</span>
                <DeltaBadge delta={band.delta} bare size="md" />
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => onToggleBand?.(String(band.key))}
                  className={classNames(styles.viewBtn, open && styles.viewBtnOpen)}
                >
                  <span className={styles.viewText}>{open ? "Hide" : "View"}</span>
                  {open ? (
                    <ExpandLessIcon className={styles.viewChevron} />
                  ) : (
                    <ExpandMoreIcon className={styles.viewChevron} />
                  )}
                </button>
              </div>

              {open && (
                <SchoolChips
                  schools={band.schools}
                  onSelect={onSelectSchool}
                  className={styles.bandChips}
                />
              )}
            </div>
          );
        })}
      </div>

        {definition && <div className={styles.definition}>{definition}</div>}
      </div>
    </div>
  );
}

export default StatusSplitTile;
